module.exports = __webpack_public_path__ + "img/sofa.082b4f0a.png";